import styled from "styled-components";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';


export const StyledExPanel = styled(ExpansionPanel)`
    margin-bottom: 20px;
    box-shadow: none !important;
    border-radius: 10px 10px 0 0 !important;
`

export const ImgContainer = styled.img`
    width: 90px;
    
`
export const RiderImageContainer = styled.div`
    width: 50px; 
    height: 50px;
    background-color: #fff;
    padding:.7rem .7rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden; 
    margin-right: 20px;

    &.secondary{
        background-color: #33393e;
    }
`
export const ClientImgContainer = styled.img`
    width: 100%;
    height: auto;
    
`

export const Marker = styled.div`
    border-radius: 50%;
    padding:1rem;
    background-color: #F5F5F5;
    margin-right: 30px;
`

export const StyledTypo = styled.span`
    color: rgba(0, 0, 0, 0.54);
    font-family: HelveticaNeueBold;
    font-size: 13px !important;
    letter-spacing: 1px;
    margin: 4px 0;
    font-weight: 400;

    &.medium{
        font-size: 15px !important;
    }

    &.big {
        color: rgb(51, 56, 62);
        font-size: 20px !important;
        font-weight: bold;
    }
    &.textCapi {
        text-transform: capitalize !important;
    }
    &.bold{
        color: rgb(51, 56, 62);
    }
    &.pill-primary{
        background-color: #ff9800;
        color:#fff;
        font-size: 12px !important;
        border-radius: 10px;
        padding: 2px 5px;
    }
    &.pill-secondary{
        font-size: 12px !important;
        background-color: #fff;
        border-radius: 10px;
        padding: 2px 5px;
    }
    &.header{
        margin: 0px;
    }
`

export const BorderContainer = styled.div`
    border-radius: 10px !important;
    border: 1px solid #d1cfc8;
    box-shadow: none !important;
    padding: 12px 24px;
    margin-bottom: 20px;
    display: flex;
    flex-grow: 1;
`

export const StyledCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70px;
    height: 70px;
    border-radius: 10px !important;
    // border:1px solid #d1cfc8;
    // padding: 12px 24px;
    margin-bottom: 20px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);

    &.available {
        background-color:#98dabd;
    }
    &.no-available {
        background-color:#f7ced6;
    }
    img{
        width:50px;
    }
    span{
        font-size: 12px !important;
    }
`
export const LoaderContainer = styled.div`
    margin: 30px 0;
    display:flex;
    justify-content: center;
    align-items: center;
`

export const Pill = styled.div`
    border-radius: 20px;
    background-color: red;
    display: inline-block;
`

export const StyledExpansionSummary = styled(ExpansionPanelSummary)`
    background-color: #33393e !important ;
    border-radius: 10px 10px 0 0 !important;
    margin: 7px 0;
` 

export const StyledPanelDetails = styled(ExpansionPanelDetails)`
    border-radius: 0 0 10px 10px; 
    border: 1px solid #d1cfc8;
    
`

export const BordedBox = styled.div`
    border: 1px solid #d1cfc8;
    border-radius: 10px;
    padding-left: 1rem; 

` 
export const RiderHeaderTable = styled.div`
    background-color: #33393e;
    border-radius: 10px 10px 0 0 ;
    padding:.7rem 0 .7rem 1rem; 
    // box-shadow: 0px 0px 10px 0px rgba(186,186,186,1);
    box-shadow: 0px 0px 9px 0px rgba(0,0,0,.12);
    // box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.12), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
    &.secondary{
        background-color:white;
        // border: 1px solid #d1cfc8;
    }

` 
export const RiderTableInfo = styled.div`
    border:1px solid #fff;
    box-shadow: 0px 0px 9px 0px rgba(0,0,0,.12);
    border-radius: 10px;

` 
export const IconBox = styled.div`
    border:1px solid #fff;
    box-shadow: 0px 0px 9px 0px rgba(0,0,0,.12);
    margin-bottom:15px;
    border-radius: 10px;

` 


// WEBPACK FOOTER //
// ./src/resources/styles/tourClients/style.js